import { OPERATIONAL_EVENT_TYPE } from '@atlaskit/analytics-gas-types';
import {
	type AnalyticsEventPayload,
	createAndFireEvent,
	type CreateUIAnalyticsEvent,
} from '@atlaskit/analytics-next';
import { type AuthError } from '@atlaskit/outbound-auth-flow-client';

import { ANALYTICS_CHANNEL } from '../constants';

enum AnalyticsActionSubject {
	THIRD_PARTY_INTEGRATION = 'thirdPartyIntegration',
}

enum AnalyticsAction {
	FAILED = 'failed',
	CONNECTED = 'connected',
}

export const triggerAnalyticsForIntegrationConnected = (
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	serviceKey: string,
	analyticsChannel: string = ANALYTICS_CHANNEL,
	teamId?: string,
	eventAttributes?: AnalyticsEventPayload,
) => {
	const fireEventWithPayload = createAndFireEvent(analyticsChannel)({
		eventType: OPERATIONAL_EVENT_TYPE,
		actionSubject: AnalyticsActionSubject.THIRD_PARTY_INTEGRATION,
		action: AnalyticsAction.CONNECTED,
		attributes: {
			integration: serviceKey,
			teamId,
			...eventAttributes,
		},
	});

	fireEventWithPayload(createAnalyticsEvent);
};

export const triggerAnalyticsForIntegrationFailed = (
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	serviceKey: string,
	analyticsChannel: string = ANALYTICS_CHANNEL,
	error?: AuthError,
	eventAttributes?: AnalyticsEventPayload,
) => {
	const fireEventWithPayload = createAndFireEvent(analyticsChannel)({
		eventType: OPERATIONAL_EVENT_TYPE,
		actionSubject: AnalyticsActionSubject.THIRD_PARTY_INTEGRATION,
		action: AnalyticsAction.FAILED,
		attributes: {
			integration: serviceKey,
			errorType: error ? error.type : undefined,
			...eventAttributes,
		},
	});

	fireEventWithPayload(createAnalyticsEvent);
};
